import {useEffect} from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from '../utils/Auth';
import { logout } from '../store/AuthCRUD';

export function Logout() {
  const { onLogout } = useAuth();
  useEffect(() => {
    logout({})
      .then(() => {
        toast.success('Logout Sukses !', {position: 'top-right'});
      })
      .catch((err:any) => console.log(err) )
      .finally(() => onLogout() );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='vw-100 vh-100' style={{position: 'absolute', zIndex: 99, background: 'white', top: 0}}>
      <span>Loading ...</span>
    </div>
  )
}
